import React from "react";
import { LabelledRadioField } from "./LabelledRadioField";
import { v4 as uuidv4 } from "uuid";

type Props = {
  innerRef?: any;
  options: {
    value: string;
    label: string;
    description: string;
  }[];
} & React.ClassAttributes<HTMLInputElement> &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;

export const LabelledRadioGroupField = ({ options, ...rest }: Props) => {
  return (
    <>
      {options.map((option, i) => (
        <LabelledRadioField
          key={i}
          id={uuidv4()}
          label={option.label}
          description={option.description}
          value={option.value}
          {...rest}
        />
      ))}
    </>
  );
};
